module.exports = __webpack_public_path__ + "static/media/oval_a.076fa9a4.svg";